import type { HTMLAttributes } from 'react';
import React from 'react';
import classNames from 'classnames';
import type { CmsLink } from '$cms/types';
import { Link } from '$quantum/atoms/Link';
import { Col, Row } from '$src-components/atoms/Grid';

import styles from './index.module.scss';

interface PopularLinks {
  readonly title: string;
  readonly links: CmsLink[];
  readonly viewAllLink?: CmsLink;
}

export interface PopularLinksCardProps extends HTMLAttributes<HTMLDivElement> {
  readonly items: PopularLinks[];
}

export function PopularLinksCard({
  items,
  className,
  children,
  ...props
}: PopularLinksCardProps): JSX.Element {
  return (
    <Row className={classNames(PopularLinksCard.displayName, styles.component, className)} {...props}>
      <Col className={styles.Col}>
        {items.map(({ title, links, viewAllLink }) => (
          <div key={title} className={styles.popular}>
            <h4>{title}</h4>
            <div>
              <ul className={classNames(styles.links, links.length > 4 && styles.twoColumns)}>
                {links.map(({ key, text, url }) => (
                  <li key={key}>
                    <a href={url}>{text}</a>
                  </li>
                ))}
              </ul>
              {viewAllLink && (
                <Link
                  className={styles.viewAllLink}
                  type="M"
                  href={viewAllLink.url}
                  iconId="arrows/arrow-right"
                  purpleIcon
                >
                  {viewAllLink.text}
                </Link>
              )}
            </div>
          </div>
        ))}
      </Col>
    </Row>
  );
}
PopularLinksCard.displayName = 'PopularLinksCard';
